import type { JSX } from "react";

import { Button, Stack, Text } from "@mantine/core";

import type { StepProps } from "@/customer-panel/components/call-intro-flow/steps/models";

export function NavButtons({ onNext, onPrev, isLoading }: StepProps): JSX.Element {
    return (
        <Stack mt="auto" pb="xl">
            <Button
                size="sm"
                fz="xs"
                loading={isLoading}
                data-testid="nav-button-continue"
                disabled={onNext === undefined}
                onClick={onNext}
                variant="filled"
            >
                Continue
            </Button>
            {onPrev && (
                <Button size="sm" fz="xs" data-testid="nav-button-back" onClick={onPrev} variant="subtle" color="white">
                    <Text style={{ textDecoration: "underline" }} c="dark.1" fz="xs">
                        Back
                    </Text>
                </Button>
            )}
        </Stack>
    );
}
